import React, { useCallback } from "react";
import { FixedSizeList as List } from "react-window";
import ReactVirtualizedAutoSizer from "react-virtualized-auto-sizer";
import { Box, Checkbox, FormControlLabel } from "@mui/material";

import { Grey1, trakrefBlue } from "../../../../color_utils";
import { trakrefFontFamily } from "../../../../utils";
import useEmailAlert from "../context/useEmailAlert";

const ListItem = ({ index, style, data }) => {
    const option = data.options[index];
    const onParentRegionChanged = data.onParentRegionChanged;
    const onEmailAlertChanged = data.onEmailAlertChanged;
    const searchEmailAlerts = data.searchEmailAlerts;
    const { id, name, emailAlerts } = option;

    const {
        selectedEmailAlert
    } = useEmailAlert();

    let isChecked = false;
    let isChecked2 = false;
    let parentCheckBoxValues = [];

    const currentId = isNaN(id) ? id : Number(id);
    const parentCheckBox = selectedEmailAlert.find(x => x.id === currentId);
    if (parentCheckBox) {
        const seletedOptionValues = emailAlerts.map(x => x.id);
        parentCheckBoxValues = parentCheckBox.emailAlerts.map(x => x.id);

        isChecked = seletedOptionValues.every(r => parentCheckBoxValues.includes(r));
        isChecked2 = seletedOptionValues.some(r => parentCheckBoxValues.includes(r));
    }

    const filteredEmailAlerts = useCallback(() => {
        return searchEmailAlerts !== "" && searchEmailAlerts.length > 0
            ? emailAlerts.filter(x => x.name.toLowerCase().includes(searchEmailAlerts.toLowerCase()))
            : emailAlerts;
    }, [searchEmailAlerts, emailAlerts])

    return (
        <div key={`${id}-${name}-box`} style={style}>
            <Box>
                <FormControlLabel
                    label={name}
                    sx={{
                        pt: "0px",
                        pb: "0px",
                        mt: "0px",
                        mb: "0px",
                        ".MuiFormControlLabel-label": {
                            color: Grey1,
                            fontSize: "14px",
                            fontFamily: trakrefFontFamily,
                            ml: "5px"
                        }
                    }}
                    control={
                        <Checkbox
                            disableRipple
                            checked={isChecked}
                            indeterminate={!isChecked && isChecked2}
                            value={id}
                            onChange={onParentRegionChanged}
                            sx={{
                                '&.MuiCheckbox-indeterminate': { color: trakrefBlue },
                                "&.Mui-checked": {
                                    color: trakrefBlue,
                                },
                            }}
                        />
                    }
                />
                {
                    <Box sx={{ display: 'flex', flexDirection: 'column', ml: 4.2 }}>
                        {
                            filteredEmailAlerts().map(emailAlert => {
                                const isTrue = parentCheckBoxValues ? parentCheckBoxValues.includes(emailAlert.id) : false;
                                return (
                                    <FormControlLabel
                                        key={emailAlert.name}
                                        label={emailAlert.name}
                                        sx={{
                                            pt: "0px",
                                            pb: "0px",
                                            mt: "0px",
                                            mb: "10px",
                                            ".MuiFormControlLabel-label": {
                                                color: Grey1,
                                                fontSize: "14px",
                                                fontFamily: trakrefFontFamily,
                                                ml: "5px"
                                            },
                                        }}
                                        control={
                                            <Checkbox
                                                disableRipple
                                                value={JSON.stringify(emailAlert)}
                                                checked={isTrue}
                                                onChange={onEmailAlertChanged}
                                                sx={{
                                                    "&.MuiCheckbox-root": {
                                                        padding: "0px 9px 0px 9px"
                                                    },
                                                    "&.Mui-checked": {
                                                        color: trakrefBlue,
                                                    }
                                                }}
                                            />
                                        }
                                    />
                                )
                            })
                        }
                    </Box>
                }
            </Box>
        </div>
    )
}

const ListPopper = ({
    onParentRegionChanged,
    onEmailAlertChanged,
    options,
    origOptions,
    searchEmailAlerts
}) => {

    const getItemSize = () => {
        const originalIndex = origOptions.length > 1 ? 1 : 0;
        const itemSize = origOptions[originalIndex].emailAlerts.filter(x => x.name.toLowerCase().includes(searchEmailAlerts.toLowerCase())).length;
        return (itemSize * 47) + 60;
    }

    return (
        <div
            style={{
                marginTop: '60px',
                minHeight: 'auto',
                height: '35vh'
            }}
        >
            {
                options.length > 0 ? (
                    <ReactVirtualizedAutoSizer>
                        {
                            ({ height, width }) => (
                                <List
                                    height={height}
                                    itemCount={options.length}
                                    itemSize={getItemSize()}
                                    width={width}
                                    itemData={{ options, onParentRegionChanged, onEmailAlertChanged, searchEmailAlerts }}
                                    style={{
                                        marginTop: "25px"
                                    }}
                                >
                                    {ListItem}
                                </List>
                            )
                        }
                    </ReactVirtualizedAutoSizer>
                ) : (
                    <div style={{
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%"
                    }}>
                        <p style={{ marginLeft: "0px", textAlign: "center" }} className="ResultItemText">Oops... No Search Results</p>
                    </div>
                )
            }
        </div >
    )
};

export default ListPopper;